/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentLocation } from '../../models/content-location';

export interface UpdateContentLocation$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * ID sekcie
 */
  sectionId: number;
      body?: ContentLocation
}

export function updateContentLocation(http: HttpClient, rootUrl: string, params: UpdateContentLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, updateContentLocation.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('sectionId', params.sectionId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

updateContentLocation.PATH = '/admin/content/{id}/location/{sectionId}';
